import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { IMG, themeBySlug } from "../data/content";

export const CaseCard = ({ c, featured = false }) => {
  const t = themeBySlug(c.theme);
  return (
    <article data-testid={`case-card-${c.id}`} className="group bg-white border border-ink/10 overflow-hidden flex flex-col h-full hover:-translate-y-1 transition-transform duration-300" style={{ borderTop: `4px solid ${t.color}` }}>
      <div className={`overflow-hidden ${featured ? "aspect-[16/9]" : "aspect-[4/3]"}`}>
        <img src={IMG[c.image]} alt={c.title} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-700" loading="lazy" />
      </div>
      <div className="p-6 flex flex-col gap-3 flex-1">
        <span className="text-[11px] font-semibold uppercase tracking-[0.18em]" style={{ color: t.color }}>{t.name} · {c.client}</span>
        <h3 className="font-display text-xl font-bold leading-snug">{c.title}</h3>
        <dl className="text-sm text-ink/70 space-y-2 mt-1">
          <div><dt className="inline font-semibold text-ink">Contexte · </dt><dd className="inline">{c.context}</dd></div>
          <div><dt className="inline font-semibold text-ink">Solution · </dt><dd className="inline">{c.solution}</dd></div>
        </dl>
        {c.metrics && (
          <div className={`grid ${c.metrics.length === 2 ? "grid-cols-2" : "grid-cols-3"} gap-2 mt-2`} data-testid={`case-metrics-${c.id}`}>
            {c.metrics.map(([v, l]) => (
              <div key={l} className="p-2 sm:p-3 min-w-0" style={{ background: `${t.color}1f` }}>
                <span className="font-display text-sm sm:text-xl font-extrabold block whitespace-nowrap">{v}</span>
                <span className="text-[11px] leading-tight text-ink/65 block mt-1 hyphens-auto break-words">{l}</span>
              </div>
            ))}
          </div>
        )}
        {c.source && (
          <a href={c.source[1]} target="_blank" rel="noopener noreferrer" data-testid={`case-source-${c.id}`} className="text-xs font-semibold underline underline-offset-4 text-ink/60 hover:text-ink">{c.source[0]}</a>
        )}
        <p className="mt-auto pt-4 border-t border-ink/10 text-sm font-semibold flex items-start gap-2">
          <ArrowUpRight size={18} style={{ color: t.color }} className="shrink-0" /> {c.result}
        </p>
      </div>
    </article>
  );
};

export const CaseLink = ({ to = "/realisations/references" }) => (
  <Link to={to} className="text-sm font-semibold underline underline-offset-4">Toutes les réalisations</Link>
);
